<div data-cy="groups-assigned-card" class="groups-assigned-card">
  <h6 class="group-name">
    {{ invitationGroup.displayName }}
  </h6>

  @if (invitationGroup.cartridgeVariants.length) {
    <div class="group-container">
      @for (
        cartridge of invitationGroup.cartridgeVariants;
        track cartridge.cartridgeId
      ) {
        <div class="group-assigned-item">
          <h6 class="cartridge-name">{{ cartridge.localizedCartridgeName }}</h6>
        </div>
      }
    </div>
  }
</div>
